<template>
  <table class="exam-table">
    <thead>
      <tr>
        <th>考试名称</th>
        <th>报名时间</th>
        <th>报名费</th>
        <th>状态</th>
        <th v-if="showAction">操作</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="exam in exams" :key="exam.id">
        <td class="exam-title" @click="onView(exam)">{{ exam.title || exam.name }}</td>
        <td>{{ formatEnrollPeriod(exam) }}</td>
        <td>{{ formatFee(exam.fee) }}</td>
        <td>
          <span :class="['status-tag', exam.statusClass]">
            {{ exam.status }}
          </span>
        </td>
        <td v-if="showAction">
          <button 
            class="btn-register" 
            v-if="exam.action === '报名'" 
            @click="!exam.disabled && onRegister(exam)"
            :disabled="exam.disabled"
            :class="{ 'btn-disabled': exam.disabled }"
            :title="exam.disabled ? '报名时间未公布' : ''"
          >立即报名</button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'ExamTable',
  props: {
    exams: {
      type: Array,
      default: () => []
    },
    showAction: {
      type: Boolean,
      default: false
    }
  },
  emits: ['register', 'view'],
  methods: {
    onView(exam) {
      this.$emit('view', exam)
    },
    onRegister(exam) {
      this.$emit('register', exam)
    },
    formatEnrollPeriod(exam) {
      // 如果有自定义的报名时间文本（如"未公布"），直接返回
      if (exam.enrollTimeText) {
        return exam.enrollTimeText
      }
      const s = exam.enroll_start_time
      const e = exam.enroll_end_time
      if (s || e) {
        const fmt = (d) => {
          if (!d) return '--'
          const dt = new Date(d)
          if (isNaN(dt.getTime())) return d
          const y = dt.getFullYear()
          const m = String(dt.getMonth() + 1).padStart(2, '0')
          const da = String(dt.getDate()).padStart(2, '0')
          const hh = String(dt.getHours()).padStart(2, '0')
          const mm = String(dt.getMinutes()).padStart(2, '0')
          return `${y}-${m}-${da} ${hh}:${mm}`
        }
      return `${fmt(s)} - ${fmt(e)}`
      }
      return '未公布'
    },
    formatFee(value) {
      const num = Number(value ?? 0)
      if (Number.isNaN(num)) return '¥0.00'
      return '¥' + num.toFixed(2)
    }
  }
}
</script>

<style scoped>
.exam-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: var(--space-4);
  background-color: var(--color-surface);
  box-shadow: var(--shadow-sm);
}

.exam-table th,
.exam-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.exam-table th { background-color: #f5f9ff; color: var(--color-primary); font-weight: var(--font-weight-bold); }

.exam-table tr:hover {
  background-color: #f9f9f9;
}

.exam-title { color: var(--color-primary); cursor: pointer; }
.exam-title:hover {
  text-decoration: underline;
}

.status-tag {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-tag.status-active { background-color: #e6f7ff; color: #1890ff; }

.status-tag.status-ended { background-color: #f6ffed; color: var(--color-success); }

.status-tag.status-processing { background-color: #fff7e6; color: var(--color-accent); }

.btn-register { background-color: var(--color-primary); color: #fff; border: 1px solid var(--color-primary); padding: 6px 16px; border-radius: var(--radius-sm); cursor: pointer; font-size: 14px; transition: background-color 0.2s; }

.btn-register:hover:not(:disabled) { background-color: #0052a3; }

.btn-register.btn-disabled,
.btn-register:disabled {
  background-color: #ccc;
  border-color: #ccc;
  cursor: not-allowed;
  opacity: 0.7;
}

.btn-register.btn-disabled:hover,
.btn-register:disabled:hover {
  background-color: #ccc;
}
</style>
